import { SnakeCaseValidator } from "./snake-case-validator";
export class PropertyValidator {
    snakeCaseValidator;
    constructor() {
        this.snakeCaseValidator = new SnakeCaseValidator();
    }
    validate(trackingObject) {
        if (typeof trackingObject.property === 'undefined')
            return;
        this.snakeCaseValidator.validate(trackingObject.property);
    }
}
